import { openBlock as e, createElementBlock as t, createStaticVNode as a } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, d = /* @__PURE__ */ a('<path fill-rule="evenodd" d="M7.823 1.956a.75.75 0 0 1-.626.856 5.25 5.25 0 0 0-3.55 8.124.75.75 0 0 1-1.243.839A6.75 6.75 0 0 1 6.967 1.33a.75.75 0 0 1 .856.626ZM7.46 14.023a.75.75 0 0 0 .776.723A6.751 6.751 0 0 0 13.048 3.52a.75.75 0 1 0-1.122.996 5.25 5.25 0 0 1-3.743 8.732.75.75 0 0 0-.723.776Z" clip-rule="evenodd"></path><path d="M5 13v-3l-3 3h3Z"></path><path fill-rule="evenodd" d="M1.51 13.204a.531.531 0 0 1 .114-.58l3-3a.531.531 0 0 1 .907.376v3a.531.531 0 0 1-.531.531H2a.531.531 0 0 1-.49-.328Zm1.773-.735h1.186v-1.186l-1.186 1.186Z" clip-rule="evenodd"></path><path d="M11 3h3l-3 3V3Z"></path><path fill-rule="evenodd" d="M10.797 6.491a.531.531 0 0 0 .579-.115l3-3A.531.531 0 0 0 14 2.469h-3a.531.531 0 0 0-.531.531v3c0 .215.13.409.328.491Zm.734-1.773V3.53h1.186l-1.186 1.187Z" clip-rule="evenodd"></path>', 5), o = [
  d
];
function h(n, c) {
  return e(), t("svg", l, [...o]);
}
const r = { render: h };
export {
  r as default,
  h as render
};
